import { CheckTreatmentType } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlControleRestitution";
import { IsiDtoSelectedRecord } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMark";
import {
    IIsiDtoGLOB007ClosingArgs, IIsiDtoGLOB007OpenArgs,
    IIsiDtoGLOB050OpenArgs, IIsiDtoGLOB054OpenArgs,
    IIsiDtoGLOB056OpenArgs, IIsiDtoGLOB062OpenArgs,
    IIsiDtoGLOB067OpenArgs, IIsiDtoGLOBXXXOpenArgs, IIsiDtoGLOB055OpenArgs, IsiDtoGLOB055OpenArgs, IIsiDtoGLOB068OpenArgs, IIsiDtoGLOB069OpenArgs
} from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { IsiButtonType, IsiIconType, IsiModeConfirm, IsiShortcut } from "./Isilog.enums";
import { IIsiUIFlowResult } from "./Isilog/Core/IIsiUIFlowResult";
import { IsiIWSPopin } from "./Isilog/Core/IsiIwsUICore";
import { IsiIWSAssociatedViewContext } from "./Isilog/GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IGLOB007CallbackArgs } from "./Isilog/Popin/IGLOB007";
import { IGLOB050CallbackArgs } from "./Isilog/Popin/IGLOB050";
import { IGLOB054CallbackArgs } from "./Isilog/Popin/IGLOB054";
import { IGLOB056CallbackArgs } from "./Isilog/Popin/IGLOB056";
import { IGLOB062CallbackArgs } from "./Isilog/Popin/IGLOB062";
import { IGLOB066CallbackArgs } from "./Isilog/Popin/IGLOB066";
import { IGLOB067CallbackArgs } from "./Isilog/Popin/IGLOB067";
import { IGLOB068CallbackArgs } from "./Isilog/Popin/IGLOB068";
import { IGLOB069CallbackArgs } from "./Isilog/Popin/IGLOB069";
import { IsiPlControleRestitution, ParamPlControleRestitution } from "./Isilog/PresentationLogic/IsiPlControleRestitution";
import { IsiGridView } from "./IsiWebGUI/IsiFW/Components/Grid/IsiGridView";
import { getPopInInstance } from "./IsiWebGUI/IsiFW/IsiFW.ui.core";
import { modifWaitStatus } from "./IsiPage.ts";

export function GLOB002() {
    return getPopInInstance<any, string>("ABOUTGLOB007", {
        code: "GLOB002",
        width: 775,
        height: "calc(100% - 100px)",
        useTs: true,
        afterClose: function (result) {
            const flow = result;
            if (flow && flow['result']) {
                if (isiApp.screen.pageName === "LIST002") {
                    // Si on ne reposte pas la VT, il faut rajouter une ligne d'historique
                    history.pushState(null, null, document.URL);
                } else {
                    poster("GLOB002True");
                }
            } else {
                // Si on ne reposte pas la VT, il faut rajouter une ligne d'historique
                history.pushState(null, null, document.URL);
            }
            return true;
        }
    });
}
window.GLOB002 = GLOB002;

export function GLOB007() {
    return getPopInInstance<IIsiDtoGLOB007OpenArgs, IGLOB007CallbackArgs>("DARMess", {
        code: "GLOB007",
        useTs: true,
        width: 380,
        height: 400,
        executeModaleChoice: function () {
            const result: IIsiDtoGLOB007ClosingArgs = this.getReturnValue();
            if (result.continue) {

                const menu = screenCore.menuManager.getEntryById(result.actionContextId);
                const actionUi = uiCore.getUiActionFormMenu(menu, menu.clientIds[0]);
                uiCore.LaunchActionUi(actionUi);

            }

        }
    });
}
window.GLOB007 = GLOB007;

//YLAR DEV118226 développmeent popin.
export function GLOB010() {
    return getPopInInstance("GLOB010", {
        code: "GLOB010",
        width: 700,
        height: 270
    });
}
window.GLOB010 = GLOB010;

export function GLOB011() {
    return getPopInInstance<any, any>("MEMOGLOB011", {
        code: "GLOB011",
        width: 958,
        height: 667,
        beforeOpen: function (options) {
            //On rajoute l'heure dans l'URL pour pouvoir recharger la msgbox a chaque fois 
            var today = new Date();
            var dayhour = today.getTime();
            var sUrl;
            var o = <HTMLInputElement>window.document.getElementById('ihdC_MEMO_' + HIDDEN);
            if (o) {
                options.args.C_MEMO = o.value;
            }

            options.args.timestamp = dayhour;
            return true;
        }
    });
}
window.GLOB011 = GLOB011;

export function GLOB017() {
    return getPopInInstance<any, any>("GLOB017", {
        useTs: true,
        code: "GLOB017",
        width: 500,
        height: 550,
        beforeOpen: function (options) {
            options.resizeToFitContent = true; //la grille définie la taille de base de la popin.
            return true;
        },
        afterClose: function (result) {
            if (result) {
                const context = uiCore.associatedViewManager.getContext(result);
                uiCore.componentManager.getComponent<IsiGridView>(context.gridViewId).clearSelectedRows();
            }
        }
    });
}
window.GLOB017 = GLOB017;

// Oubli de mot de passe
function GLOB020() {
    return getPopInInstance("GLOB020", {
        code: "GLOB020",
        width: 550,
        height: 455,
        afterClose: function (result) {
            if (result) {
                //YLAR 14/02/2019 DYSF80013 : On reposte même dans le cas du annuler, afin de garder le bouton prec
                poster();
            }
        }
    });
}
window.GLOB020 = GLOB020;

//SDEN 09/05/2016 DEV118246 PopIn Changement de mot de passe LDAP 
export function GLOB021() {
    return getPopInInstance("GLOB021", {
        code: "GLOB021",
        width: 452,
        height: 208,
        afterClose: function (result) {
            if (result) {
                if (result[0] == "OK") {
                    uiCore.showMessage(result[1]);
                }
            }
        }
    });
}
window.GLOB021 = GLOB021;

// DGRA - 13/05/2016 - DEV118248 : popin de fusion word
export function GLOB026() {
    return getPopInInstance<any, any>("PERSOEXPORTGLOB007", {
        code: "GLOB026",
        width: 450,
        height: 480,
        useTs: true,
        afterClose: function (result) {
            if (result) {
                if (result.associatedViewContextId) {
                    const context = uiCore.associatedViewManager.getContext(result.associatedViewContextId);
                    if (context) {
                        uiCore.componentManager.getComponent<IsiGridView>(context.gridViewId).clearSelectedRows();
                    }
                }
                if (result.refreshForm) {
                    uiCore.reloadPage();
                }
                
            }
        }
    });
}
window.GLOB026 = GLOB026;


// DGRA - 29/04/2016 - DEV118250 : popin de reprise d'infos lors de la creation d'instance
export function GLOB029() {
    return getPopInInstance("CreationInstance", {
        code: "GLOB029",
        width: 478,
        height: 253
    });
}
window.GLOB029 = GLOB029;

//CDES 09/05/2016 T118251 PopIn Bureau père
//ARAN 28/02/2019 Dysf.85794 - Agrandissement de la hauteur pour permettre l'affichage d'une dizaine de bureau dans la liste.
export function GLOB031() {
    return getPopInInstance("GLOB031", {
        title: "Bureau père",
        code: "GLOB031",
        width: 378,
        height: 240,
        useTs: true,
        afterClose: function (result) {
            //Pas d'affichage de popIn, repostage de la page
            if (result[0] == "1" && !result[1]) {
                poster();
            }
            //Affichage de la popIn Traitement terminé puis repostage de la page
            else if (result[0] == "1" && result[1] == "TRAITEMENTOK") {
                uiCore.showMessage(result[2], { popin: true, callback: function () { poster(); } });
            }
            //Affichage de la popIn Traitement terminé, pas de repostage de la page
            // YLAR 15/02/2019 : on ne passe plus dans ce code normalement car ne pas reposter le formulaire fait planter la navigation.
            else if (result[0] == "0" && result[1] == "TRAITEMENTOK") {
                history.pushState(null, null, document.URL);
                uiCore.showMessage(result[2], { popin: true });
            }
            //Affichage de la popIn Traitement échoué, pas de repostage de la page
            else if (result[1] && result[1] == "TRAITEMENTPASOK") {
                history.pushState(null, null, document.URL);
                uiCore.showMessage(result[2], { popin: true });
                //uiCore.showErrorMessage(result[2]);
            }
        }
    });
}
window.GLOB031 = GLOB031;

//CDES 28/04/2016 T118252 PopIn Choix d'une instance 
export function GLOB032() {
    return getPopInInstance("RECUPINSTANCE", {
        title: "Choix d'une instance",
        code: "GLOB032",
        width: 450,
        height: 450,
        afterClose: function () {
            // CLEM - PB0017954 - INC0218023 - Dysf81436 - Annuler sur le planning des actions
            uiCore.setSubmit(true);
        }
    });
}
window.GLOB032 = GLOB032;

// GLIG - 18/05/2016 - DEV118253 - Ajouter canevas
function GLOB033() {
    return getPopInInstance("GLOB033", {
        code: "GLOB033",
        width: 529,
        height: 150
    });
}
window.GLOB033 = GLOB033;

// DGRA - 28/04/2016 - popin duplication des contenus et destinataires d'un message type
export function GLOB034() {
    return getPopInInstance("DuplicationMsgType", {
        code: "GLOB034",
        width: 250,
        height: 148
    });
}
window.GLOB034 = GLOB034;

// YLAR 06/04/2016 DEV118255 popin
export function GLOB035() {
    return getPopInInstance("GLOB035", {
        code: "GLOB035",
        width: 600,
        height: 650
    });
}
window.GLOB035 = GLOB035;

export function GLOB050() {
    return getPopInInstance<IIsiDtoGLOB050OpenArgs, IGLOB050CallbackArgs>("CONFIGREQUESTGLOB050", {
        useTs: true,
        code: "GLOB050",
        width: 915,
        height: 425,
        afterClose: function (result: any) {
            if (result === "needRepost") {
                window.validateFromGLOB050 = true;
                // si la config a été modifié on relance la requete.
                screenCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_VALIDATEv2);
            } else if (result === "addHistory") {
                history.pushState(null, null, document.URL);
            }
        }
    });
}
window.GLOB050 = GLOB050;

export function GLOB051() {
    return getPopInInstance("METIERSUB", {
        title: "Domaine de substitution",
        code: "GLOB051",
        width: 440,
        height: 115
    });
}
window.GLOB051 = GLOB051;

// Motif de refus
export function GLOB053() {
    return getPopInInstance("GLOB053", {
        code: "GLOB053",
        height: 350,
        width: 450
    });
}
window.GLOB053 = GLOB053;

// Retour à l'envoyeur
// 
export function GLOB054() {
    return getPopInInstance<IIsiDtoGLOB054OpenArgs, IGLOB054CallbackArgs>("GLOB054", {
        code: "GLOB054",
        width: 450,
        height: 331,
        beforeOpen: configureGLOB054,
        useTs: true
    });
}
window.GLOB054 = GLOB054;

//SPRI - 11/12/2019 - Création
function configureGLOB054(options) {
    //On donne une hauteur de la popin différente pour les téléphones et tablettes
    if (uiCore.isTouchMode() === true) {
        if (uiCore.getClient().isPhone() === true) {
            options.height = 450;
        } else {
            options.height = 350;
        }
    }
    return true;
}

// Restitution
// CDES 24/08/2016 Dys75756 : Augmentation de la largeur de la popIn
export function GLOB055() {
    return getPopInInstance<IIsiDtoGLOB055OpenArgs, any>("GLOB055", {
        code: "GLOB055",
        width: 832,
        height: 420,
    });
}
window.GLOB055 = GLOB055;

// Générer les codes-barres (depuis bons de réception + DA Génération de codes-barres)
export function GLOB056() {
    return getPopInInstance<IIsiDtoGLOB056OpenArgs, IGLOB056CallbackArgs>("GLOB056", {
        code: "GLOB056",
        width: 572,
        height: 146,
        // Indique que la pop-in gère du Type Script.
        useTs: true
    });
}
window.GLOB056 = GLOB056;

export function GLOB059() {
    return getPopInInstance("GLOB059", {
        code: "GLOB059",
        width: 650,
        height: 400,
        useTs: true
    });
}
window.GLOB059 = GLOB059;

export function GLOB060() {
    return getPopInInstance("GLOB060", {
        code: "GLOB060",
        width: 572,
        height: 190,
        useTs: true
    });
}
window.GLOB060 = GLOB060;

export function HELP016() {
    return getPopInInstance<any, any>("GENER_PROCED", {
        code: "HELP016",
        useTs: true,
        width: 450,
        height: 220
    });
}
window.HELP016 = HELP016;

//CDES 03/05/2016 T118233 PopIn Bibliothèque d'icônes 
export function IsiAsyncTreatmentResult() {
    return getPopInInstance("IsiAsyncTreatmentResult", {
        code: "GLOB019",
        useTs: true,
        width: 800,
        height: 300,
        beforeOpen: configureGLOB019AutoResize,
    });
}
window.IsiAsyncTreatmentResult = IsiAsyncTreatmentResult;

//CDES 03/05/2016 T118233 PopIn Bibliothèque d'icônes 
export function IsiIconBiblio() {
    return getPopInInstance("IsiIconBiblio", {
        title: "Bibliothèque d'icônes",
        code: "GLOB019",
        useTs: true,
        width: 800,
        height: 445,
        beforeOpen: configureGLOB019
    });
}
window.IsiIconBiblio = IsiIconBiblio;

//CDES 11/05/2016 T118232 PopIn Bibliothèque de formes
export function IsiFormBiblio() {
    return getPopInInstance("IsiFormBiblio", {
        title: "Bibliothèque de formes",
        code: "GLOB019",
        useTs: true,
        width: 800,
        height: 400,
        beforeOpen: configureGLOB019
    });
}
window.IsiFormBiblio = IsiFormBiblio;

export function IsiConnexionManagement() {
    return getPopInInstance("IsiConnexionManagement", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 450,
        beforeOpen: configureGLOB019,
        afterClose: function (result) {
            // CLEM - Dysf74182 - feedback quand pas de modif
            if (result && result[0] == "ibtnYes" && result[2] != 'noFeedBack') {
                uiCore.showFeedback(result[1]);
            }
        }
    });
}
window.IsiConnexionManagement = IsiConnexionManagement;

export function IsiInputListValue() {
    return getPopInInstance("IsiInputListValue", {
        code: "GLOB019",
        useTs: true,
        width: 400,
        height: 106,
        beforeOpen: configureGLOB019
    });
}
window.IsiInputListValue = IsiInputListValue;

export function IsiFillReplace() {
    return getPopInInstance("IsiFillReplace", {
        code: "GLOB019",
        useTs: true,
        width: 650,
        height: 475,
        beforeOpen: configureGLOB019
    });
}
window.IsiFillReplace = IsiFillReplace;

export function IsiGenDialog() {
    return getPopInInstance("IsiGenDialog", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 150,
        beforeOpen: configureGLOB019
    });
}
window.IsiGenDialog = IsiGenDialog;

export function IsiCheckInstance() {
    return getPopInInstance("IsiCheckInstance", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 150,
        beforeOpen: configureGLOB019
    });

}
window.IsiCheckInstance = IsiCheckInstance;

export function IsiAdminChamp() {
    return getPopInInstance("IsiAdminChamp", {
        title: "Ajout Update Delete de champ",
        code: "GLOB019",
        useTs: true,
        width: 800,
        height: 481,
        openWith: "auto",
        beforeOpen: configureGLOB019
    });
}
window.IsiAdminChamp = IsiAdminChamp;

// DGRA - DEV118231 - popin generer ligne de contrat
export function IsiGenerateRowAgreement() {
    return getPopInInstance("IsiGenerateRowAgreement", {
        code: "GLOB019",
        useTs: true,
        width: 845,
        height: 420,
        beforeOpen: configureGLOB019
    });
}
window.IsiGenerateRowAgreement = IsiGenerateRowAgreement;

// DGRA - DEV118231 - popin associer objet a une ligne de contrat
// ' HMNA 06/11/2018 - PB0019024: La longueur du pop-up « Association contrat » n'était pas suffisant pour afficher correctement le libellé de l'écran souhaité.
export function IsiAssociateContract() {
    return getPopInInstance("IsiAssociateContract", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 150,
        beforeOpen: configureGLOB019
    });
}
window.IsiAssociateContract = IsiAssociateContract;

// SDEN DEV118241 Propagation du marquage (ADM071)
export function IsiPropagateMarking() {
    return getPopInInstance("IsiPropagateMarking", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 250,
        beforeOpen: configureGLOB019,
        afterClose: function (result) {
            if (result) {
                if (result[1] == "OK") {
                    uiCore.showMessage(result[2]);
                }
            }
        }
    });
}
window.IsiPropagateMarking = IsiPropagateMarking;

// SDEN DEV118244 Tester la connexion LDAP
export function IsiTestLDAPConnection() {
    return getPopInInstance("IsiTestLDAPConnection", {
        code: "GLOB019",
        useTs: true,
        width: 400,
        height: 150,
        beforeOpen: configureGLOB019,
        afterClose: function (result) {
            if (result && result[1] === "OK") {
                uiCore.showMessage(result[2]);
            }
        }
    });
}
window.IsiTestLDAPConnection = IsiTestLDAPConnection;
/**
 * Configuration de la Glob019 avec gestion de redimentionnement auto.
 * @param options options d'ouverture 
 * @param args arguments d'ouverture
 * @returns
 */
function configureGLOB019AutoResize(options, args) {

    return configureGLOB019.apply(this, [options]) && configureWidthAndHeight(options);
}

function createParam(options: any) {
    var args = options.args;

    // GREN 14/04/2022 - on sérialise avec JSON
    const param = new Array<string>();

    for (var i = 0; i < args.length; i++) {
        param.push(args[i].toString());
    }

    options.args = {};

    return param;
}

function configureGLOB019(options) {
    options.height = options.height || 182;
    options.width = options.width || 317;

    const param = createParam(options);

    this.setArgs({
        inputValueType: this.getId(),
        paramConstructor: JSON.stringify(param)
    });
   
    return true;
}

// DEV118240 - Propagation des libelles d'un bureau
export function IsiPropagateLabel() {
    return getPopInInstance("IsiPropagateLabel", {
        code: "GLOB019",
        useTs: true,
        width: 368,
        height: 250,
        beforeOpen: configureGLOB019
    });
}
window.IsiPropagateLabel = IsiPropagateLabel;

// GLIG - 18/05/2016 - DEV118235
export function IsiInputGenerateObject() {
    return getPopInInstance("IsiInputGenerateObject", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 150,
        beforeOpen: configureGLOB019
    });
}
window.IsiInputGenerateObject = IsiInputGenerateObject;

// DEV118236 - Affichage des scripts Xn
export function IsiConfirmCustomScript() {
    return getPopInInstance("IsiConfirmCustomScript", {
        code: "GLOB019",
        useTs: true,
        width: 400,
        height: 260,
        beforeOpen: configureGLOB019
    });
}
window.IsiConfirmCustomScript = IsiConfirmCustomScript;

// DEV118236 - Affichage des scripts Xn lors de la recompilation de la base
export function IsiTreatDBOnConnexion() {
    return getPopInInstance("IsiTreatDBOnConnexion", {
        code: "GLOB019",
        useTs: true,
        width: 450,
        height: 180,
        beforeOpen: configureGLOB019
    });
}
window.IsiTreatDBOnConnexion = IsiTreatDBOnConnexion;

// GLIG - 19/05/2016 - DEV118242
export function IsiFillConditionalWorkflow() {
    return getPopInInstance("IsiFillConditionalWorkflow", {
        code: "GLOB019",
        useTs: true,
        width: 550,
        height: 260,
        beforeOpen: configureGLOB019
    });
}
window.IsiFillConditionalWorkflow = IsiFillConditionalWorkflow;

export function IsiOptionsPlanning() {
    return getPopInInstance("IsiOptionsPlanning", {
        code: 'GLOB019',
        useTs: true,
        width: 508,
        height: 260,
        beforeOpen: configureWidthAndHeightWithScreenMax
    });
}

window.IsiOptionsPlanning = IsiOptionsPlanning;


export function IsiDatePicker() {
    return getPopInInstance("IsiDatePicker", {
        code: 'GLOB019',
        useTs: true,
        width: 408,
        height: 350,
        beforeOpen: configureWidthAndHeightWithScreenMax
    });
}

window.IsiDatePicker = IsiDatePicker;

export function IsiPlanifDatePicker() {
    return getPopInInstance("IsiPlanifDatePicker", {
        code: 'GLOB019',
        useTs: true,
        width: 508,
        height: 500,
        beforeOpen: configureWidthAndHeightWithScreenMax
    });
}

window.IsiPlanifDatePicker = IsiPlanifDatePicker;

// JSOU - 02/07/2016 - DEV120784
export function IsiRestoreRequestLine(associatedViewContext: IsiIWSAssociatedViewContext,
    keyValues: IsiDtoSelectedRecord[],
    libelle: string,
    checkTreatment: CheckTreatmentType): Promise<IIsiUIFlowResult> {
    return new Promise((resolve, reject) => {
        uiCore.showConfirm({
            message: libelle,
            iconType: IsiIconType.Question,
            confirmMode: IsiModeConfirm.YesNoCancel,
            callback: function (result) {
                if (result === IsiButtonType.Yes) {
                    const plRestoreRequestLine: IsiPlControleRestitution = new IsiPlControleRestitution();
                    let associatedViewId: string;
                    if (associatedViewContext) {
                        associatedViewId = associatedViewContext.id;
                    }
                    const opts: ParamPlControleRestitution = {
                        values: keyValues,
                        checkTreatment: checkTreatment,
                        associatedViewId: associatedViewId
                    }
                    plRestoreRequestLine.Restore(opts).then((restoreResult) => {
                        if (restoreResult.messages && restoreResult.messages.length > 0) {
                            const message = restoreResult.messages[0];
                            uiCore.showFeedback(message.message, message.isError);
                            if (!message.isError && associatedViewContext) {
                                // on veut décocher les checkbox     
                                associatedViewContext.clearSelectedRows();
                                associatedViewContext.refresh();
                            }
                        }
                        resolve({ result: true, continue: false });
                        if ((uiCore.currentScreen as any ).afterRestoreRequestLine) {
                            (uiCore.currentScreen as any).afterRestoreRequestLine(associatedViewContext);
                        }
                    })
                        .catch((o) => {
                            resolve({ result: true, continue: false });
                        })
                        .finally(() => {
                            modifWaitStatus(false, false, LOADING);
                        });
                } else {
                    if (result === IsiButtonType.No) {
                        let associatedViewId: string;
                        if (associatedViewContext) {
                            associatedViewId = associatedViewContext.id;
                        }
                        GLOB055().open(
                            IsiDtoGLOB055OpenArgs.fromJS({ associatedviewContextId: associatedViewId, selectedPk: keyValues }),
                            {
                                callback: function (sReturn) {
                                    resolve({ result: true, continue: (sReturn && sReturn.length >= 2) })
                                    if ((uiCore.currentScreen as any).afterRestoreRequestLine) {
                                        (uiCore.currentScreen as any).afterRestoreRequestLine(associatedViewContext);
                                    }
                                },
                                resizeToFitContent: uiCore.isTouchMode()
                            }
                        );
                    } else {
                        resolve({ result: true, continue: false });            
                    }
                }
            }
        });
    });
}

// MAXB T134719 Propagation des droits d'accès (ADM012LACCESECRAN)
export function GLOB057() {
    return getPopInInstance("GLOB057", {
        code: "GLOB057",
        width: 554,
        height: 236,
    });
}
window.GLOB057 = GLOB057;

// MAXB T134720/T134723 Rétablir les droits d'accès (ADM012LACCESECRAN)
export function GLOB058() {
    return getPopInInstance("GLOB058", {
        code: "GLOB058",
        width: 400,
        height: 300,
    });
}
window.GLOB058 = GLOB058;

//RBED 15/01/2020 - Decision
export function RealizeActionProc() {
    return getPopInInstance<IIsiDtoGLOB062OpenArgs, IGLOB062CallbackArgs>("GLOB062", {
        code: "GLOB062",
        height: 375,
        width: 450,
        useTs: true
    });
}
window.RealizeActionProc = RealizeActionProc;

export function getPopin(name: string): Promise<IsiIWSPopin<unknown, unknown>> {

    return new Promise((resolve: (screen: IsiIWSPopin<unknown, unknown>) => void, reject): void => {
        import(
            /* webpackChunkName: "Business/[request]" */
            `./Business/${name}`).then((module) => {
                const popin = new module[name]() as IsiIWSPopin<unknown, unknown>;
                if (popin) {
                    popin.getInstance().then((instance) => {
                        resolve(instance);
                    });
                } else {
                    resolve(popin);
                }

            }).catch((e) => {
                console.log(e);
            });
    });
}

export function getPopinArgs(popinArgsName: string): Promise<any> {

    return new Promise((resolve: (popinArgs: string) => void, reject): void => {
        import(
            /* webpackChunkName: "Dtos/[request]" */
            `./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins`).then((module) => {
                resolve(module[popinArgsName]);
            }).catch((e) => {
                console.log(e);
            });
    });
}

//YBRE 31/08/2021 - Contrôle d'affectation
export function getControleAffectationPopinInstance() {
    let popinHeight;
    if (uiCore.getClient().isPhone()) {

        popinHeight = 700;
    }
    else {
        popinHeight = 500;
    }
    return getPopInInstance<any, any>("GLOB063", {
        code: "GLOB063",
        height: popinHeight,
        width: 700,
        useTs: true,
        beforeOpen: function (options) {
            if (uiCore.isTouchMode() && uiCore.getClient().isPhone()) {
                options.width = window.screen.availWidth - window.screen.pixelDepth;
            }
            return true;
        }
    });
}
window.getControleAffectationPopinInstance = getControleAffectationPopinInstance;

function iws_ChangeSelectionState(value: string, arg1: boolean) {
    throw new Error("Function not implemented.");
}

//SPRI 08/11/2021 - Emplacement
export function getEmplacementPopinInstance() {
    return getPopInInstance("GLOB064", {
        code: "GLOB064",
        height: 350,
        width: 550,
        beforeOpen: configureWidthAndHeight,
        useTs: true
    });
}

//JHAL 24/01/2022 - Confirmation de l'article
// AMAG : 13/08/2025 - on ne fait pas le resizeToFitContent pour la GLOB065
export function getConfirmationArticlePopinInstance() {
    return getPopInInstance("GLOB065", {
        code: "GLOB065",
        height: 450,
        width: 750,
        beforeOpen: configureWidthAndHeightGlobb065,
        useTs: true
    });
}

//SPRI 21/02/2022 - Configuration du complément FastMail
export function getConfigurationFastMail() {
    return getPopInInstance<IIsiDtoGLOBXXXOpenArgs, IGLOB066CallbackArgs>("GLOB066", {
        code: "GLOB066",
        height: 550,
        width: 817,
        beforeOpen: configureWidthAndHeight,
        useTs: true
    });
}
window.getConfigurationFastMail = getConfigurationFastMail;

function configureWidthAndHeight(options: any) {
    if (uiCore.isTouchMode() && uiCore.getClient().isPhone()) {
        options.width = window.screen.availWidth - window.screen.pixelDepth;
        options.height = window.screen.availHeight - window.screen.pixelDepth;
    } else if (uiCore.isTouchMode()) {
        options.resizeToFitContent = true;
    }
    return true;
}

function configureWidthAndHeightWithScreenMax(options: any) {
    if (uiCore.isTouchMode() && uiCore.getClient().isPhone()) {
        const width = window.screen.availWidth - window.screen.pixelDepth;
        const height = window.screen.availHeight - window.screen.pixelDepth;
        if (width < options.width) {
            options.width = width;
        }
        if (height < options.height) {
            options.height = height;
        }
        
    }

    const param = createParam(options);

    this.setArgs({
        inputValueType: this.getId(),
        paramConstructor: JSON.stringify(param)
    });
    
    return true;
}

function configureWidthAndHeightGlobb065(options: any) {
    if (uiCore.isTouchMode() && uiCore.getClient().isPhone()) {
        options.width = window.screen.availWidth - window.screen.pixelDepth;
        options.height = window.screen.availHeight - window.screen.pixelDepth;
    }
    return true;
}

export function AjoutRequetePopulation() {
    return getPopInInstance("AjoutRequetePopulation", {
        code: "GLOB019",
        useTs: true,
        width: 400,
        height: 150,
        beforeOpen: configureGLOB019
    });
}
export function GLOB067() {
    return getPopInInstance<IIsiDtoGLOB067OpenArgs, IGLOB067CallbackArgs>("GLOB067", {
        code: "GLOB067",
        height: 650,
        width: 817,
        beforeOpen: configureWidthAndHeight,
        useTs: true,
        afterClose: function (result) {
            if (result && result[0] === "true") {
                // faut pas que ça dure trop longtemps
                uiCore._feedbackOptions.timerDuration = 5000;
                uiCore.showMessage(result[1]);
                uiCore._feedbackOptions.timerDuration = 10000;
            }
        }
    });
}
window.GLOB067 = GLOB067;


/**
 * gère le retour des popin de traduction
 * @param result
 */
function treatTranslationResult(result: IGLOB068CallbackArgs | IGLOB069CallbackArgs) {
    if (result?.refreshForm) {
        if (result.lastMajEnreg) {
            setValueToCtrlForTranslationResult(result);
        }
        uiCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_REFRESH);
    }
}

/** 
 * Met la valeur traduite dans le contrôle & met à jour la date de MAJ
 * @param result
 * @param ctrl
 */
function setValueToCtrlForTranslationResult(result: IGLOB068CallbackArgs | IGLOB069CallbackArgs) {
    let ctrl = iwsAllCtrls.getCtrl(result.ctrlCode);
    if (ctrl) {
        const defaultOrEmptyValue = result.newDefaultValue ? result.newDefaultValue : '';
        ctrl.setValueResyncFromDb(result.newCurrentTradValue ? result.newCurrentTradValue : defaultOrEmptyValue);
        if (result.newCurrentTradValue) {
            jQuery(`#${jQuery.escapeSelector(ctrl.fullId)}`)?.data("translated", "True");
        } else {
            jQuery(`#${jQuery.escapeSelector(ctrl.fullId)}`)?.data("translated", "False");
        }
    }

    ctrl = iwsAllCtrls.getCtrl('ihdD_MAJENREG');
    if (ctrl) {
        ctrl.setValueNoChange(result.lastMajEnreg);
    }
}

export function GLOB068() {
    return getPopInInstance<IIsiDtoGLOB068OpenArgs, IGLOB068CallbackArgs>("GLOB068", {
        code: "GLOB068",
        height: "calc(100% - 100px)",
        beforeOpen: (options: any) => {
            options.width = jQuery(`#${options.args.ctrlClientId}`).outerWidth() + 30;
            options.resizeToFitContent = true;
            return true;
        },
        afterClose: treatTranslationResult,
        useTs: true
    });
}
window.GLOB068 = GLOB068;

export function GLOB069() {
    return getPopInInstance<IIsiDtoGLOB069OpenArgs, IGLOB069CallbackArgs>("GLOB069", {
        code: "GLOB069",
        beforeOpen: (options: any) => {
            options.resizeToFitContent = true;
            return true;
        },
        afterClose: treatTranslationResult,
        useTs: true
    });
}
window.GLOB069 = GLOB069;

/**
 * Gestion de l'import des objets sqls
 * @returns
 */
export function AsyncImportSQLObject() {
    return getPopInInstance("AsyncImportSQLObject", {
        code: "GLOB019",
        useTs: true,
        width: 800,
        height: 461,
        beforeOpen: configureGLOB019AutoResize,
    });
}
window.AsyncImportSQLObject = AsyncImportSQLObject;